import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import clicksound from '../components/music/click.mp3';
import { useTranslation } from "react-i18next";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationEN from "../components/language/en/translation_en.json";
import translationID from "../components/language/id/translation_id.json";

const resources = {
  en: {
    translation: translationEN,
  },
  id: {
    translation: translationID,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});
const ModalExit = ({ show, onClose, player1Name, player2Name, Englishscore0, Englishscore1, player1Score, player2Score }) => {
  const { t } = useTranslation();
    const navigate = useNavigate();
    if (!show) return null;
    const handleOk = () => {
        const currentDateTime = new Date();
        const formattedDateTime = `${currentDateTime
          .getDate()
          .toString()
          .padStart(2, "0")}/${(currentDateTime.getMonth() + 1)
          .toString()
          .padStart(2, "0")}/${currentDateTime.getFullYear()} ${currentDateTime
          .getHours()
          .toString()
          .padStart(2, "0")}:${currentDateTime
          .getMinutes()
          .toString()
          .padStart(2, "0")}`;

        const newHistory = {
          date : formattedDateTime,
          status : "menyerah",
          user : [
              {
                nama : player1Name,
                gamescore : player1Score,
                englishscore : Englishscore0
                
            },
            {
                nama : player2Name,
                gamescore : player2Score,
                englishscore : Englishscore1
                
            }
          ]
        };

        try {
          if (typeof localStorage !== "undefined") {
            const existingHistory =
              JSON.parse(localStorage.getItem("gameDakonHistory")) || [];
            const updatedHistory = [...existingHistory, newHistory];
            localStorage.setItem("gameDakonHistory", JSON.stringify(updatedHistory));
          } else {
            console.warn("Local storage is not supported on this browser.");
          }
        } catch (error) {
          console.error("Error accessing local storage:", error);
        }
        const audio = new Audio(clicksound);
        audio.play();
        navigate("/");
    };
    const handleno = () => {
        onClose();
    }
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
        <div className="bg-white rounded-2xl shadow-lg py-10 px-5 sm:py-8 max-w-sm w-full relative">
          <h2 className="text-center text-blue-500 text-2xl sm:text-xl font-bold mb-4">
            {t("end_game_prompt")}
          </h2>
          <div className="space-y-3 mb-4 flex flex-col">
            <button
              className="button-save block text-white w-full font-bold py-2 px-4 rounded-full shadow-lg transition-all duration-200 ease-in-out"
              onClick={handleOk}
            >
              {t("yes")}
            </button>
            <button
              className="button-save block text-white w-full font-bold py-2 px-4 rounded-full shadow-lg transition-all duration-200 ease-in-out"
              onClick={handleno}
            >
              {t("no")}
            </button>
          </div>
        </div>
      </div>
    );
};

export default ModalExit;
